import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { reportService } from '../services/api';
import styles from './Reports.module.css';

function formatDate(str) {
    if (!str) return '—';
    return new Date(str).toLocaleDateString('ar-SY', { year: 'numeric', month: 'short', day: 'numeric' });
}

export default function Reports() {
    const [reports,  setReports]  = useState([]);
    const [loading,  setLoading]  = useState(true);
    const [deleting, setDeleting] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        reportService.list()
            .then((r) => {
                const data = Array.isArray(r.data) ? r.data : (r.data.data ?? []);
                setReports(data);
            })
            .catch(console.error)
            .finally(() => setLoading(false));
    }, []);

    const handleDelete = async (id) => {
        if (!window.confirm('هل تريد حذف هذا التقرير؟')) return;
        setDeleting(id);
        try {
            await reportService.delete(id);
            setReports((prev) => prev.filter((r) => r.id !== id));
        } catch {
            alert('فشل حذف التقرير');
        } finally {
            setDeleting(null);
        }
    };

    if (loading) return <div className={`${styles.state} text-ar`}>جاري التحميل...</div>;

    return (
        <div className={`${styles.page} text-ar`}>
            <div className={styles.pageHeader}>
                <div>
                    <h1>التقارير</h1>
                    <p className={styles.sub}>تقاريرك المحفوظة</p>
                </div>
                <button className={styles.newBtn} onClick={() => navigate('/reports/create')}>
                    + تقرير جديد
                </button>
            </div>

            {reports.length === 0 ? (
                <div className={styles.empty}>
                    <p>لا توجد تقارير محفوظة بعد</p>
                    <button className={styles.newBtn} onClick={() => navigate('/reports/create')}>
                        إنشاء أول تقرير
                    </button>
                </div>
            ) : (
                <div className={styles.list}>
                    {reports.map((r) => (
                        <div key={r.id} className={styles.item}>
                            <div className={styles.itemInfo}>
                                <h3 className={styles.itemTitle}>{r.title}</h3>
                                {r.description && <p className={styles.itemDesc}>{r.description}</p>}
                                <div className={styles.itemMeta}>
                                    <span>{formatDate(r.generated_at)}</span>
                                    {r.report_data?.total_protests != null && (
                                        <span>{r.report_data.total_protests?.toLocaleString('ar-SY')} احتجاج</span>
                                    )}
                                </div>
                            </div>
                            <div className={styles.itemActions}>
                                <button
                                    className={styles.viewBtn}
                                    onClick={() => navigate(`/reports/${r.id}`)}
                                >
                                    عرض
                                </button>
                                <button
                                    className={styles.deleteBtn}
                                    onClick={() => handleDelete(r.id)}
                                    disabled={deleting === r.id}
                                >
                                    {deleting === r.id ? '...' : 'حذف'}
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
